import { Suspense } from 'react';
import { lazily } from 'react-lazily';

//**************************/
// Common Packages (unmoved)
// These are still in use by other packages, so they can't be removed just yet.
// Probably can symlink them like the linked MFE's, but I'm not sure if that's a good idea.
//**************************/

const { WelcomeModal: WelcomeModalRemote } = lazily(() => import('@bonusly/common-onboarding'));
export const WelcomeModal = () => (
	<Suspense>
		<WelcomeModalRemote />
	</Suspense>
);

const { ReviewSolicitationsModal: ReviewSolicitationsModalRemote } = lazily(() => import('@bonusly/common-onboarding'));
export const ReviewSolicitationsModal = () => (
	<Suspense>
		<ReviewSolicitationsModalRemote />
	</Suspense>
);

const { RecapPrintView } = lazily(() => import('@bonusly/common-performance-recap'));
export const PerformanceRecap = () => (
	<Suspense>
		<RecapPrintView />
	</Suspense>
);
